import { useCallback, useEffect, useState } from "react";
import { useTourContext } from "../contexts/TourContext";

// Offers a finished tour again to someone coming back from a long break. The
// offer is stamped as soon as it is shown rather than when it is answered, so
// walking away from it counts as having been asked
const useTourRefresher = ({ tourId }) => {
   const { isRefresherDue, markRefresherOffered, requestTour } = useTourContext();
   const [isOffering, setIsOffering] = useState(false);
   const [hasBeenOffered, setHasBeenOffered] = useState(false);

   const isDue = isRefresherDue(tourId);

   useEffect(() => {
      if (!isDue || hasBeenOffered) {
         return;
      }

      setHasBeenOffered(true);
      setIsOffering(true);
      markRefresherOffered(tourId);
   }, [isDue, hasBeenOffered, markRefresherOffered, tourId]);

   const acceptRefresher = useCallback(() => {
      setIsOffering(false);
      requestTour(tourId);
   }, [requestTour, tourId]);

   const declineRefresher = useCallback(() => setIsOffering(false), []);

   return { isOffering, acceptRefresher, declineRefresher };
};

export default useTourRefresher;
